import React, { useEffect, useState } from "react";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toastmodal from "../Toastmodal";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import Nodatafound from "../Nodatafound";

function Aminitylist() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const [modal_backdrop, setmodal_backdrop] = useState(false);

  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [paginate,setPaginate]=useState("");
  const [pagenum,setPagenum]=useState(1);

  const [formerror, setError] = useState({});

  const [title, setTitle] = useState("");
  const [titleedit, setTitleedit] = useState("");

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [blogdata, setBlogdata] = useState([]);
  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/amenities/get-amenity`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setBlogdata(data.data);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/amenities/delete-amenity/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200) {
      const deletedata = await response.json();

      setToastmodal(true);
      setToastmessage("Sucessfully Deleted");
      setToasttype("success");
      setToastlarge(false);
      getinfo();
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData();
    }
    else {
      const deletedata = await response.json();

      setToastmodal(true);
      setToastmessage(response.message);
      setToasttype("error");
      setToastlarge(true);
    }
  };


    const PostData = async (e) => {
        e.preventDefault();
        
        let formvalid=true;
        const errors = {};
      
        if (!title) {
            errors.title = "Title is required!";
            formvalid=false;
          }
        setError(errors);
        if (
            formvalid===true
        ) {
          const res = await fetch(
            `${Config.apiurl}/api/v1/crm/amenities/add-amenity`,
            {
              method: "POST",
    
              body: JSON.stringify({
                 title
              }),
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
                "Content-type": "application/json; charset=UTF-8",
              },
            }
          );
    
          if (res.status === 200 ) {
            setToastmodal(true);
            setToastmessage("Sucessfully added Aminity ");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);
           
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            const data = await res.json();
    
            setToastmodal(true);
            setToastmessage(data.message);
            setToasttype("error");
            setToastlarge(true);
          }
        }
        else{
          console.log("error");
        }
      }


      function tog_backdrop(ids) {
        setmodal_backdrop(!modal_backdrop);
        setPageid(ids);
        const getinfo1 = async (e) => {
          const res = await fetch(`${Config.apiurl}/api/v1/crm/amenities/get-amenity/${ids}`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          });
          const data1 = await res.json();
          const data = data1.data;
          if (res.status === 200) {
            setTitle(data[0].title);

          } 
          else if(res.status === 401){
            handleUnauthorized();
            getinfo1();
          }
          else {
            console.log("error");
          }
        };
        getinfo1();
      }

      const UpdateData = async (id) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/amenities/update-amenity/${id}`,
          {
            method: "PUT",
            body: JSON.stringify({
               title
            }),
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        );
  
          if (res.status === 200) {
            const data = await res.json();
            setToastmodal(true);
            setToastmessage(data.message);
            setToasttype("success");
            setToastlarge(true);
              setmodal_animationFlip(false);
              setPageid('');
              setTitle('')
              setmodal_backdrop(!modal_backdrop);

            } 
            else if(res.status === 401){
              handleUnauthorized();
              UpdateData();
            }
            else {
              const data = await res.json();
              setToastmodal(true);
            setToastmessage(data.message);
            setToasttype("error");
            setToastlarge(true);
            setmodal_animationFlip(false);
            setmodal_backdrop(false);
          }
      };
  return (
    <>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                  <div className="card-body">
                  <h4 className="card-title">Add Aminity</h4>
                  <form className="forms-sample" >
                          <div className="form-group mb-1">
                            <label htmlFor="exampleInputUsername1">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Title"
                              name="title"
                              value={title}
                              onChange={(e)=>setTitle(e.target.value)}
                            />
                               <label style={{ color: "red" }}>{formerror.title}</label>
                          </div>
                          <button
                            type="submit"
                            onClick={PostData}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>

                </form>

                    </div>
                    <div className="card-body">
                      <h4 className="card-title">Aminity List</h4>
                      <div className="table-responsive pt-3">
                      {blogdata?.length>0?
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Sl.No</th>
                              <th>Title</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {blogdata.map((element, i) => {
                              return (
                                <>
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>{element.title}</td>
                                 

                                    <td className="actions_td">
                                      <Link
                                      to="#"
                                        // onClick={() => deleteblog(element._id)}
                                        onClick={() => tog_animationFlip(element._id)}

                                        className="margins-2 action_icons"
                                      >
                                        <i className="fa-solid fa-trash" />
                                      </Link>
                                     
                                        <Link
                                          data-bs-toggle="modal"
                                         
                                          onClick={() =>
                                            tog_backdrop(element._id)
                                          }
                                     
                                          className="fa-solid fa-pen action_icons"
                                       
                                        ></Link>
                                     
                                    
                                              {/* <Link to={"/blogview/" + element._id}   className="action_icons" >
                                             <i className="fa-solid fa-eye" />
                                             </Link> */}
                                           
                                      <ToastContainer />
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                        :
                        <Nodatafound/>
                      }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}

      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Aminity"}
          />
        ) : (
          ""
        )}


<Modal
      isOpen={modal_backdrop}
      toggle={() => {
        tog_backdrop();
      }}
      backdrop={"static"}
      id="staticBackdrop"
      centered
    >
      <ModalHeader
        className="modal-title modal-header bg-light p-3"
        id="staticBackdropLabel"
        toggle={() => {
          tog_backdrop();
        }}
      >Aminity Edit</ModalHeader>
      <ModalBody className="">
        <div className="mt-4">
          <label for="orderId" className="form-label">
            Title
          </label>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        
        

          <div className="modal-footer p-3">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
                onClick={() => {
                  tog_backdrop();
                }}
              >
                Close{" "}
              </button>
              {/* <!-- <button type="submit" className="btn btn-success" id="add-btn">Save</button> --> */}
              <button
                type="button"
                className="btn db-save-single-button"
                id="edit-btn"
                onClick={() => UpdateData(pageid)}
                style={{color:"red",background:"white",marginLeft:"4px"}}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
    </>
  );
}

export default Aminitylist;
